import type { CountryCode } from 'libphonenumber-js';

/**
 * Represents internationalization (i18n) information that drives all region-specific display
 * and formatting logic in the application.
 */
export type I18nInfo = {
	/**
	 * The IANA timezone identifier (e.g., "America/New_York").
	 */
	timezone: string;
	/**
	 * The BCP 47 language tag representing the user's locale (e.g., "en-US")
	 */
	locale: string;
	/**
	 * The day the week starts on, represented as a number (0 = Sunday, 1 = Monday, etc.).
	 */
	firstDayOfWeek: number;
	/**
	 * The country code in ISO 3166-1 alpha-2 format (e.g., "US" for the United States, "AU" for Australia).
	 */
	countryCode: string;
	/**
	 * The default starting bounding box when viewing a map. Generally assumed to be the bounding box of the
	 * tenant's configured country.
	 */
	defaultLonLatBox?: [number, number, number, number];
};


/**
 * A hook to access the i18n information object to drive region-specific display and formatting logic
 *
 * @returns The i18n information object
 */
export function useI18n(): I18nInfo & { phoneCountryCode: CountryCode } {
	const i18n = (typeof(window) !== 'undefined' ? (window?.['__i18n'] ?? {}) : {}) as I18nInfo
	return {
		...i18n,
		// Convenience property to avoid having to do the cast yourself
		phoneCountryCode: i18n.countryCode as CountryCode
	}
}
